import React, { useRef, useEffect } from 'react';

import { debounce } from '../../../utils/generic';

function TagsInput({ value, onChange, isFocused, disabled }) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (isFocused) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (value.length === 0 && inputRef.current.textContent.length > 0) {
      inputRef.current.textContent = '';
    }
  }, [value]);

  const handleEnter = (e) => {
    if (e.keyCode === 13 || ((e.ctrlKey || e.metaKey) && e.keyCode === 86)) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }

      const content = inputRef.current.textContent;

      if (!content) return;

      let new_values = content.split(',');

      new_values = new_values.map((val) => val.trim()).filter((el) => el.length);
      onChange([...value, ...new_values]);
      inputRef.current.textContent = '';
      inputRef.current.focus();
    }
  };
  const handleRemove = (index) => () => {
    if (disabled) return;

    const new_values = (value || []).filter((_, i) => i !== index);

    onChange(new_values);
  };

  return (
    <div>
      {(value || []).filter(Boolean).map((elm, index) => (
        <div className='tags-div' key={elm}>
          <div className='d-flex'>
            {elm}
            <div className='input_modal_close' onClick={handleRemove(index)}>
              &times;
            </div>
          </div>
        </div>
      ))}
      {!disabled ? (
        <div
          className='input_modal_input font-14 black'
          contentEditable={!disabled}
          onKeyDown={(e) => {
            e.persist();
            debounce(handleEnter, 50)(e);
          }}
          placeholder='Add and press enter'
          ref={inputRef}
        />
      ) : null}
      <style jsx>{`
        .tags {
          max-height: 70px;
          overflow: auto;
          padding: 2px;
          border: 1px solid #aabfc3;
          border-radius: 0.25rem;
          transition:
            border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
        }

        .tags-div {
          color: #1f2d3d;
          background-color: #eff2f7;
          border: 1px solid #e0e6ed;
          border-radius: 15px;
          margin: 2px;
          padding: 5px 0px 5px 9px;
          display: inline-block;
        }

        .input_modal_close {
          cursor: pointer;
          text-align: center;
          width: 18px;
          height: 18px;
          background-color: #fff;
          border-radius: 50%;
          margin: 2px 9px 0px 5px;
          display: flex; /* Enable flexbox */
          justify-content: center; /* Center horizontally */
          align-items: center;
        }

        .input_modal_input {
          padding: 6px 5px;
          border: none;
          outline: none;
          display: inline-block;
        }

        .input_modal_input:empty::before {
          content: attr(placeholder);
          font-size: 12px;
        }
      `}</style>
    </div>
  );
}

TagsInput.defaultProps = {
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
  value: [],
  isFocused: false
};

export default TagsInput;
